import { ReactComponent as OutlineCalendar } from "assets/svg/outline-calendar.svg";
import { ReactComponent as OutlineCoin } from "assets/svg/outline-coin.svg";
import { ReactComponent as OutlineDocsFilled } from "assets/svg/outline-document-filled.svg";
import { ReactComponent as OutlineGraph } from "assets/svg/outline-graph.svg";
import { ReactComponent as HomeIcon } from "assets/svg/outline-home-2.svg";
import { ReactComponent as OutlinePackage } from "assets/svg/outline-package.svg";
import { ReactComponent as OutlineSettings } from "assets/svg/outline-settings.svg";
import { ReactComponent as OutlineShare } from "assets/svg/outline-share-2.svg";
import { ReactComponent as OutlineUsers } from "assets/svg/outline-users.svg";
import { ReactComponent as TeamOutline } from "assets/svg/outline-team.svg";
import InviteOthers from "../invite-others";
import BusinessAnalytics from "./business-analytics-tab/BusinessAnalytics";
// import GroupSessions from "./group-sessions/GroupSessions";
import Billing from "./billing/Billing";
import OrchidProDashboardHomepage from "./home/DashboardHome";
import NotesAndForms from "./notes-and-forms/NotesAndForms";
import OrchidStorage from "./orchid-storage";
import PatientCharts from "./patient-charts/PatientCharts";
import Settings from "./settings";
import Policies from "./views/Policies";
import OneOnOneSessions from "./views/one-one-sessions/OneOnOneSessions";
import GroupMember from "./group-practice/members/Member";

export const ROUTES: {
  path: string;
  name: string;
  icon?: React.ReactNode;
  component: any;
  requiresSubscription: boolean;
  exact: boolean;
  identifier: string;
  hide_in_sidebar?: boolean;
  bypassProfileApprovedToUsePlatform?: boolean;
  featureName?: Feature; // Only necessary if feature needs gating
  roleFeatureName?: string; // For role-based access control
}[] = [
  {
    path: "homepage",
    name: "Dashboard",
    component: OrchidProDashboardHomepage,
    icon: <HomeIcon />,
    exact: true,
    requiresSubscription: false,
    identifier: "pro-dashboard-home",
    bypassProfileApprovedToUsePlatform: true,
    roleFeatureName: "dashboard",
  },
  {
    path: "schedule",
    name: "Calendar",
    component: OneOnOneSessions,
    icon: <OutlineCalendar />,
    exact: true,
    requiresSubscription: true,
    identifier: "pro-calendar",
    featureName: "calendar",
    roleFeatureName: "calendar",
    bypassProfileApprovedToUsePlatform: true,
  },

  {
    path: "patient-charts",
    name: "Client Chart",
    component: PatientCharts,
    icon: <OutlineUsers />,
    exact: true,
    requiresSubscription: true,
    identifier: "patient-charts",
    featureName: "patient-charts",
    roleFeatureName: "patient-charts",
  },
  {
    path: "notes-and-forms",
    name: "Template Library",
    component: NotesAndForms,
    icon: <OutlineDocsFilled />,
    exact: true,
    requiresSubscription: true,
    identifier: "pro-notes-and-forms-page",
    featureName: "notes-and-forms",
    roleFeatureName: "notes-and-forms",
  },
  {
    path: "billing",
    name: "Billing",
    icon: <OutlineCoin />,
    component: Billing,
    exact: true,
    requiresSubscription: true,
    identifier: "pro-billing",
    roleFeatureName: "billing",
  },
  {
    path: "business-analytics",
    name: "Business Analytics",
    component: BusinessAnalytics,
    icon: <OutlineGraph />,
    exact: true,
    requiresSubscription: true,
    featureName: "business-analytics",
    identifier: "pro-business-analytics",
    roleFeatureName: "business-analytics",
  },
  {
    path: "team/members",
    name: "Teams",
    component: GroupMember,
    icon: <TeamOutline />,
    exact: true,
    requiresSubscription: true,
    identifier: "pro-team-page",
  },
  {
    path: "orchid-storage",
    name: "Orchid Storage",
    component: OrchidStorage,
    icon: <OutlinePackage />,
    exact: true,
    requiresSubscription: true,
    featureName: "orchid-storage",
    identifier: "pro-orchid-storage",
    roleFeatureName: "orchid-storage",
  },
  {
    path: "policies",
    name: "Policies",
    component: Policies,
    exact: true,
    hide_in_sidebar: true,
    requiresSubscription: false,
    identifier: "pro-policies",
    roleFeatureName: "policies",
  },
  {
    path: "invite",
    name: "Invite to Orchid",
    component: InviteOthers,
    icon: <OutlineShare />,
    exact: true,
    requiresSubscription: true,
    identifier: "pro-invite-to-orchid-page",
    roleFeatureName: "invite",
  },
  {
    path: "settings/my-profile",
    name: "Settings",
    component: Settings,
    icon: <OutlineSettings />,
    exact: true,
    requiresSubscription: false,
    identifier: "pro-settings",
    roleFeatureName: "settings",
  },
];

export const SIDEBAR_ROUTES = ROUTES;
